var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticIcn3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "static-icn3",
    transform: "translate(-874 -1203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 104,
    height: 104,
    rx: 10,
    transform: "translate(874 1203)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2403",
    "data-name": "Groupe 2403",
    transform: "translate(899 1236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2897",
    "data-name": "Trac\\xE9 2897",
    d: "M396.771.328c-.156,1.293-.264,2.595-.481,3.878-.242,1.436-.583,2.855-.878,4.269-6.3-.341-12.7-6.761-13.141-13,1.806-.37,3.626-.77,5.458-1.106.972-.179,1.965-.247,2.948-.365h3.633c.169.031.337.076.508.091a1.8,1.8,0,0,1,1.856,1.872c.014.206.063.41.1.615Z",
    transform: "translate(-342.77)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2898",
    "data-name": "Trac\\xE9 2898",
    d: "M-6,168.131a9.8,9.8,0,0,1,.971-1.358c1.918-1.916,3.791-3.888,5.831-5.667a11.6,11.6,0,0,1,7.424-3.045,13.7,13.7,0,0,1,1.934.23c-.164.276-.227.408-.313.523a95.163,95.163,0,0,0-6.719,10.271.634.634,0,0,1-.772.367,14.7,14.7,0,0,0-5.211.474l-.455.106c-1.484.345-2.008.112-2.691-1.2Z",
    transform: "translate(0 -144.834)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2899",
    "data-name": "Trac\\xE9 2899",
    d: "M241.225,385.877c-1.239-.706-1.425-1.179-1.233-2.618a27.622,27.622,0,0,0,.462-4.819,1.9,1.9,0,0,1,1.186-1.966c3.051-1.918,6.05-3.918,9.066-5.891.259-.169.5-.359.913-.652a12.162,12.162,0,0,1,.217,1.987,12.514,12.514,0,0,1-3.48,7.918c-1.724,1.858-3.555,3.616-5.357,5.4a5.913,5.913,0,0,1-.955.639Z",
    transform: "translate(-217.108 -331.877)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2900",
    "data-name": "Trac\\xE9 2900",
    d: "M487.461-3.422c-.033-.205-.083-.409-.1-.615a1.8,1.8,0,0,0-1.857-1.872c-.171-.015-.339-.06-.508-.091h2.461Z",
    transform: "translate(-433.461)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2901",
    "data-name": "Trac\\xE9 2901",
    d: "M137.859,18.245a19.477,19.477,0,0,0,15.38,15.132c-.357.828-.679,1.654-1.061,2.45a50.217,50.217,0,0,1-9.011,12.834,81.815,81.815,0,0,1-16.7,13.234c-.333.205-.5.126-.734-.113-1.137-1.155-2.278-2.305-3.44-3.435a.606.606,0,0,1-.155-.763,9.572,9.572,0,0,0,.664-4.067,5.148,5.148,0,0,0-5.516-5.075,17.815,17.815,0,0,0-3.49.618.928.928,0,0,1-1.055-.263c-1.027-1.07-2.083-2.114-3.145-3.15a.523.523,0,0,1-.112-.783,77.6,77.6,0,0,1,14.738-17.941A49.22,49.22,0,0,1,137.5,18.382C137.606,18.337,137.717,18.3,137.859,18.245Zm5.389,18.529a8.779,8.779,0,1,0-8.81,8.763A8.82,8.82,0,0,0,143.248,36.774Z",
    transform: "translate(-101.833 -21.404)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2902",
    "data-name": "Trac\\xE9 2902",
    d: "M70.29,307.989a7.093,7.093,0,0,1-2.122,4.554,56.806,56.806,0,0,1-9.554,7.976c-.674.428-1.374.818-2.081,1.19a1.809,1.809,0,0,1-2.22-.211,1.828,1.828,0,0,1-.228-2.267,39.11,39.11,0,0,1,5.614-7.9c1.082-1.231,2.21-2.423,3.361-3.59a7.335,7.335,0,0,1,4.877-2.258C69.547,305.38,70.3,306.124,70.29,307.989Z",
    transform: "translate(-52.795 -274.973)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2903",
    "data-name": "Trac\\xE9 2903",
    d: "M165.345,387.469c-1.739.907-3.469,1.836-5.224,2.717-1.034.518-1.825.234-2.652-.845l5.044-4.7Z",
    transform: "translate(-144.312 -344.861)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M70.143,276.251l2.7,2.7L68.159,284a1.772,1.772,0,0,1-.732-2.434C68.3,279.784,69.229,278.03,70.143,276.251Z",
    transform: "translate(-64.625 -249.175)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2905",
    "data-name": "Trac\\xE9 2905",
    d: "M278.809,136.56a5.258,5.258,0,1,1,5.225,5.27A5.289,5.289,0,0,1,278.809,136.56Z",
    transform: "translate(-251.433 -121.212)",
    fill: "#06d2e0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticIcn3);
export default __webpack_public_path__ + "static/media/static-icn3.c6624c8b6797469e69e28375bf97bcb6.svg";
export { ForwardRef as ReactComponent };